module.exports = __webpack_public_path__ + "static/media/s1.23f09bbd.jpg";